export default class FullScreen{
    constructor(val){
        this.fullarea = document.getElementById(val)
    }
    full(){   
        if (this.fullarea.requestFullscreen) {

            this.fullarea.requestFullscreen();

        } else if (this.fullarea.webkitRequestFullScreen) {

            this.fullarea.webkitRequestFullScreen();

        } else if (this.fullarea.mozRequestFullScreen) {

            this.fullarea.mozRequestFullScreen();

        } else if (this.fullarea.msRequestFullscreen) {

            // IE11

            this.fullarea.msRequestFullscreen();

        }

        

    }
    unfull(){
        if (document.exitFullscreen) {

            document.exitFullscreen();

        } else if (document.webkitCancelFullScreen) {

            document.webkitCancelFullScreen();

        } else if (document.mozCancelFullScreen) {

            document.mozCancelFullScreen();

        } else if (document.msExitFullscreen) {

            document.msExitFullscreen();

        }
    }
}